<script>
import { mapActions } from 'vuex'
export default {
  name: 'DeleteProductModal',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      progress: false,
    }
  },
  methods: {
    ...mapActions('product', ['deleteProduct']),
    ...mapActions('manage', ['getAvailableProducts']),
    async onSubmit() {
      this.progress = true

      const response = await this.deleteProduct(this.product.id)

      this.$notifier({
        response,
        errorMsg: 'Cannot Delete Product',
        successTitle: 'Product deleted',
        successMsg: `Product ${this.product.name} successfully deleted`,
      }).then(success => {
        if (success) {
          this.$emit('update:visible', false)
          this.getAvailableProducts()
          this.$router.push({ name: 'products' })
        }
      })

      this.progress = false
    },
  },
}
</script>

<template>
  <state-dialog
    title="Delete product"
    v-bind="$attrs"
    :close-on-click-modal="false"
    v-on="$listeners"
  >
    <el-icon
      slot="icon"
      name="warning"
    />
    <el-icon
      slot="subicon"
      name="delete"
    />
    <template slot="message">
      <p>Are you sure you want to delete this product?</p>
    </template>

    <div class="modal__footer">
      <el-button
        type="danger"
        :loading="progress"
        class="el-button--wide"
        @click.stop="onSubmit"
      >
        Delete
      </el-button>
    </div>
  </state-dialog>
</template>
